import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter  } from 'react-router-dom';
import { setActiveModalAction } from '../../action';
import swal from 'sweetalert';
import { fromStore, modalsSelector } from '../../selectors';
import cn from 'classnames';
import ErrorContainer from '../../components/utils/ErrorContainer';
import Switch from '../../components/utils/Switch';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { addGroup, updateGroup } from '../../action/groupgoods';
import Input from '../../components/utils/Input';

function GroupModal() {
  const dispatch = useDispatch();
  const id = useSelector(modalsSelector).groupgood;
  const loading = useSelector(fromStore.loaderModalGroupSelector);
  const loadingUpdate = useSelector(fromStore.loaderUpdateGoodSelector);
  const group = useSelector(fromStore.groupById(id));
  const goods = useSelector(state => state.good.list);
  const categories = useSelector(fromStore.categoryListSelector);
  const settings = useSelector(state => state.settings.init.categories);
  const noGroupedCategoriesIds = settings ? [ settings.mainWok, settings.meatWok, settings.toppingWok, settings.souceWok ] : []
  const [goodsOptions, setGoodsOptions] = useState((goods || []).filter((item) => {
    if (item.isGroup) return false;
    if (noGroupedCategoriesIds.includes(item.category.id)) return false;
    return true;
  }).map((item) => ({ value: item.id, label: item.name, category: item.category.id })));

  const loader = loading || loadingUpdate;

  const initData = group ? {
    title: group.title,
    titleChanger: group.titleChanger,
    category: group.category,
    active: group.active,
    hiddenClient: group.hiddenClient,
    goods: group.goods ? group.goods.map((good) => ({
      id: good.id,
      title: good.groupTitle,
      order: good.order,
      isDefault: good.isDefault,
    })) : group.items.map((good) => ({
      id: good.id,
      title: good.groupTitle,
      order: good.order,
      isDefault: good.isDefault,
    })),
  } : {
    title: '',
    titleChanger: '',
    category: null,
    active: true,
    hiddenClient: false,
    goods: [
      {
        id: null,
        title: '',
        order: 0,
        isDefault: true,
      }
    ],
  };
  const [data, setData] = useState(initData);
  const isEditMode = id !== 'new';

  useEffect(() => {
    let filteredGoods = (goods || []).filter((item) => {
      if (item.isGroup) return false;
      if (noGroupedCategoriesIds.includes(item.category.id)) return false;
      return true;
    }).map((item) => ({ value: item.id, label: item.name, category: item.category.id }))

    const categoryId = data.category ? data.category.id ? data.category.id : data.category : null;
    if (categoryId) filteredGoods = filteredGoods.filter((good) => good.category === categoryId);

    if (data.goods && data.goods.length > 0) {
      const ids = data.goods.map((item) => item.id);
      if (ids && ids.length > 0) filteredGoods = filteredGoods.filter((good) => !ids.includes(good.value))
    }

    setGoodsOptions(filteredGoods);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goods, data, data.category, data.goods, settings]);

  const onChangeInput = (field) => (e) => {
    const updated = {...data};
    updated[field] = e.target.value;
    setData(updated);
  };

  const onChangeSwitch = (field) => (value) => {
    const updated = {...data};
    updated[field] = value;
    
    setData(updated);
  };

  const onSelectGood = (e, index) => {
    const updated = {...data};
    if (!data.category) updated.category = e.category;
    updated.goods[index].id = e.value;
    setData(updated);
  }

  const onChangeGoodInput = (value, index, field) => {
    const updated = {...data};
    updated.goods[index][field] = value;
    setData(updated);
  }

  const setDefaultGood = (e, index) => {
      if (e.target.checked) {
        const updated = {...data};
        updated.goods = updated.goods.map((good, goodIndex) => {
          if (goodIndex !== index) return { ...good, isDefault: false };
          return { ...good, isDefault: true };
        });
        setData(updated);
      }
  }

  const onDeleteGood = (index) => {
    const deletedGoods = data.goods[index];
    const entityGood = goods.find((good) => good.id === deletedGoods.id);
    const name = entityGood && entityGood.name ? entityGood.name : deletedGoods.title || `id: ${deletedGoods.id}`
    if (!deletedGoods.id) {
      const updated = {...data};
      updated.goods = updated.goods.filter((good, goodIndex) => goodIndex !== index);
      if (!updated.goods.find((good) => good.isDefault) && updated.goods[0]) updated.goods[0].isDefault = true;
      return setData(updated || []);
    }
    return swal({
      title: "Удаление товара из группы",
      text: `Вы действительно хотите удалить товар ${name}?`,
      icon: "warning",
      dangerMode: true,
      buttons: ["Отмена", "Удалить"],
    }).then((willdelete) => {
      if (willdelete) {
        const updated = {...data};
        updated.goods = updated.goods.filter((good, goodIndex) => goodIndex !== index);
        if (!updated.goods.find((good) => good.isDefault) && updated.goods[0]) updated.goods[0].isDefault = true;
        return setData(updated || []);
      }
    })
  }

  const onAddRowGood = () => {
    const updated = {...data};
    if (data.goods.length === 3) return;
    if (data.goods.length === 0) {
      updated.goods = [{
        id: null,
        title: '',
        order: 0,
        isDefault: true,
      }];
    } else {
      updated.goods.push({
        id: null,
        title: '',
        order: 0,
      });
    }
    setData(updated);
  }

  const renderCategory = () => {
    if (!data.category) return;
    const categoryId = data.category.id ? data.category.id : data.category;
    const entityCategory = categories.find((category) => category.id === categoryId);
    if (!entityCategory) return;

    return (
      <div className="form-group">
        <span style={{ color: '#000', fontSize: '1.2rem' }}>{`Категория: ${entityCategory.title ? entityCategory.title : `id - ${entityCategory.id}`}`}</span>
      </div>
    )
  }

  const isValid = () => {
    const { title, category, goods } = data;
    if (title && category && !isEmpty(goods) && goods.length > 1 && !goods.find((item) => !item.id || !item.title)) return true;
    return false;
  }

  const onClose = () => !loader && dispatch(setActiveModalAction({ field: 'groupgood', value: null }));

  const onSubmit = async (e) => {
    e.preventDefault();
    const categoryId = data.category ? data.category.id ? data.category.id : data.category : null;

    if (!isEditMode) {
      const result = await dispatch(addGroup({...data, category: categoryId}));
      if (result) onClose();
    } else {
      const result = await dispatch(updateGroup(id, {...data, category: categoryId}));
      if (result) onClose();
    }
  };

  const setFields = (fields) => {
    const updated = {...data};
    for (let field in fields) {
      updated[field] = fields[field];
    }
    setData(updated);
  }

  const setActive = (value) => {
    if(!value && !!data.activeOnTime) {
      const fields = {
        active: value,
        activeOnTime: false
      }
      setFields(fields)
    } else {
      onChangeSwitch('active')(value);
    }
  }

  const renderGoods = () => {
    return (data.goods || []).map((good, index) => {
      const entityGood = goods.find((item) => item.id === good.id);
      return (
        <div style={{ display: 'flex', gap: '10px' }}>
          <div style={{ width: '250px' }}>
            <label>Товар *</label>
            <Select 
              isLodaing={loader}
              isDisabled={loader}
              value={entityGood ? { value: entityGood.id, label: entityGood.name, category: entityGood.category.id} : good.id ? { value: good.id, label: 'Товар не найден', category: data.category } : null}
              options={goodsOptions}
              onChange={(e) => onSelectGood(e, index)}
              isClearable={false}
              placeholder="Выберите товар..."
              noOptionsMessage={() => 'Нет товаров'}
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>Короткое название *</label>
            <Input 
              placeholder='Короткое название'
              disabled={loader}
              isControlledInput={true}
              value={good.title}
              onChange={(e) => {
                let value = e.target.value;
                if (value.length > 5) value = value.slice(0, 5);
                onChangeGoodInput(value, index, 'title')
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>Приоритет</label>
            <Input 
              type='number'
              placeholder='Приоритет'
              disabled={loader}
              isControlledInput={true}
              value={good.order}
              onChange={(e) => {
                let value = +e.target.value;
                if (value < 0) value = 0;
                if (value > 99) value = 99;
                onChangeGoodInput(value, index, 'order')
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>По умолчанию</label>
            <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', flexWrap: 'wrap', height: 'calc(1.5em + 1.3rem + 2px)' }}>
              <input style={{ width: '15px', height: '15px' }} disabled={loader} type="checkbox" checked={!!good.isDefault} onChange={(e) => setDefaultGood(e, index)}/>
            </div>
          </div>
          {data.goods && data.goods.length > 1 && <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>.</label>
            <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', flexWrap: 'wrap', height: 'calc(1.5em + 1.3rem + 2px)'  }}>
              <button type="button" onClick={() => onDeleteGood(index)} className='btn btn-sm btn-clean btn-icon btn-icon-md'><i className='flaticon2-trash'/></button>  
            </div>
          </div>}
        </div>
      )
    })
  }
  
  return (
    <form onSubmit={onSubmit}>
      <div  className="modal fade show" style={{ display: 'block' }}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
          <div className="modal-content" style={{ height: '100%'}}>
            <div className="modal-header">
              <h5 className="modal-title">{isEditMode ? 'Редактирование группы товаров' : 'Добавление группы товаров'} </h5>
              <button onClick={onClose} type="button" className="close">
              </button>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="g-name" className="form-control-label">Заголовок (для внутреннего использования) *</label>
                  <input disabled={loader} type="text" value={data.title} className="form-control" id="g-name" onChange={onChangeInput('title')} />
                </div>

                <div className="form-group">
                  <label htmlFor="g-name" className="form-control-label">Обозначение опций</label>
                  <input disabled={loader} type="text" value={data.titleChanger} className="form-control" id="g-name" onChange={onChangeInput('titleChanger')} />
                </div>

                {renderCategory()}
                {renderGoods()}
                {data.goods.length < 3 && <dutton onClick={onAddRowGood} className='btn btn-primary'>+</dutton>}

                <div className='kt-separator kt-separator--border-dashed kt-separator--space-md'/>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Включен</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={(value) => setActive(value)} checked={!!data.active}/>
                    </div>
                </div>
                <div className="form-group row" style={{ marginBottom: 0 }}>
                    <label className="col-xl-3 col-lg-3 col-form-label">Скрыт для клиентов</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch disabled={loader} nomargin={true} onChange={onChangeSwitch('hiddenClient')} checked={!!data.hiddenClient}/>
                    </div>
                </div>

                <ErrorContainer field="modalGroup" hasCloseButton={true}/>
            </div>

            <div className="modal-footer">
              <button disabled={loader} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
              <button
                type="submit"
                disabled={!isValid() || loader}
                className={cn({ 'btn btn-primary  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': loader })}>
                  {isEditMode ? 'Сохранить' : 'Добавить группу'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default withRouter(GroupModal);